import { BaseService } from 'core/services';
import CoverageTypeRouteService from './CoverageTypeRouteService';

class CoverageTypeService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new CoverageTypeRouteService());
    }
}

export default CoverageTypeService;
